var Component = require("!../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!./scripts/mypage.js"),
  /* template */
  require("!!../../node_modules/vue-loader/lib/template-compiler?id=data-v-68dacc3f!../../node_modules/vue-loader/lib/template-loader?raw&engine=pug!./templates/mypage.pug"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/components/MyPage.vue
// module id = 326
// module chunks = 1